import React from 'react';

function Settings() {
    return (
        <div className="container">
            <br></br>
            <div className="container">
                <div className="row row-header">
                    <div className="col-12">
                        <h1>Settings</h1>
                        <p>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Settings;
